/// <reference types="vite-plugin-svgr/client" />
import { ThemeProvider } from '@mui/system';
import { AuthProvider } from 'src/components/auth';
import { QueryProvider } from 'src/components/queryProvider/QueryProvider';
import { RumProvider } from 'src/components/rumProvider';
import { theme } from 'src/utils/theme';

import { SnackbarUtilsProvider } from '../snackbar';
import { AppProps } from './App.interface';

export const App = (props: AppProps) => {
  return (
    <RumProvider>
      <ThemeProvider theme={theme}>
        <SnackbarUtilsProvider>
          <QueryProvider>
            <AuthProvider>{props.children}</AuthProvider>
          </QueryProvider>
        </SnackbarUtilsProvider>
      </ThemeProvider>
    </RumProvider>
  );
};
